export interface RewardListResponse {
  rewardList: Reward[] | null;
}

export interface Reward {
  name: RewardName;
  points: number | null;
  expire: string | null;
}

export enum RewardName {
  controlVisit = 'CONTROL_VISIT',
  annualEyeCheck = 'ANNUAL_EYE_CHECK',
  birthday = 'BIRTHDAY',
  visionProfile = 'VISION_PROFILE',
}
